import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../lib/api-client';

interface HealthResponse {
  status: string;
  version: string;
  environment: string;
  dbConfigured: boolean;
}

export const Route = createFileRoute('/health')({
  component: HealthPage,
});

function HealthPage() {
  const { data, error, isLoading } = useQuery<HealthResponse>({
    queryKey: ['health'],
    queryFn: () => apiFetch<HealthResponse>('/public/health'),
  });

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-semibold tracking-tight">Health</h1>
      {isLoading && <p className="text-neutral-600">Loading...</p>}
      {error && (
        <p className="text-red-600">
          Failed to load: {(error as Error).message}
        </p>
      )}
      {data && (
        <pre className="rounded border bg-white p-4 text-sm">
          {JSON.stringify(data, null, 2)}
        </pre>
      )}
    </div>
  );
}
